import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Autocomplete,
  FormControl,
  FormHelperText,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import { Cause } from '../../types/models/Cause'
import { CreateIssueDTO } from '../../types/models/Issue'
import ProductCard from '../ProductCard/ProductCard'
import './styles/CreateIssue.scss'
import UserSelect from '../AppHeader/UserSelect'
import { grey, red } from '@mui/material/colors'

type Props = {
  onClose?: () => void;
}

const margin = 'dense'
const variant = 'standard'

const CreateIssue = observer((props: Props) => {
  const open = RootStore.modalsUi.createIssue
  const device = RootStore.modalsUi.device
  
  // Колбэк закрытия модала
  const { onClose } = props;

  const [causes, setCauses] = React.useState(0)
  const [assigned, setAssigned] = React.useState<number | undefined>(0)
  
  const [error, setError] = React.useState<any>()

  const allRoles = device?.causes.map((obj) => obj.role)
  const roles = [{ id: 0, value: 'Любой', description: 'default permision' }]
  allRoles?.forEach((role) => {
    const arrayId = roles.map((obj) => obj.id)
    if (role && !arrayId.includes(role.id)) {
      roles.push(role)
    }
  })

  const hundleClose = () => {
    setCauses(0)
    setAssigned(0)
    RootStore.modalsUi.hundleCreateIssue(false)
  
    // Вызываем колбэк, если он передан
    if (onClose) {
      onClose();
    }
  }

  const hundleChangeCauses = (cause: Cause) => {
    setCauses(cause.id)
    setAssigned(cause.role?.id)
  }
  const handleChangeAssigned = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAssigned(Number(event.target.name))
  }

  if (!device) return <></>

  const hundleChange = async () => {
    const form: CreateIssueDTO = {
      roleId: assigned ? assigned : undefined,
      deviceId: device.id,
      causeId: causes ? causes : undefined,
      urgent: false,
      source: 'Авария',
    }
  
      const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.createIssue(form)
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setError(null)
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
        setError(data.property)
      }
    }
  }

  const hundleChangeUrgent = async () => {
    const form: CreateIssueDTO = {
      roleId: assigned ? assigned : undefined,
      deviceId: device.id,
      causeId: causes ? causes : undefined,
      urgent: true,
      source: 'Авария',
    }
  
      const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.createIssue(form)
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setError(null)
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
        setError(data.property)
      }
    }
  }

  const hundleSwitchDevice = async () => {
    const operation = (!device.is_started) ? 'Старт' : 'Стоп'

    const createForm: CreateIssueDTO = {
      roleId: undefined,
      deviceId: device.id,
      causeId: undefined,
      urgent: false,
      source: 'Работа',
    }
  
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      if (!device.is_started) {
        const issue = await RootStore.userAction.createIssue(createForm)
        // console.log(JSON.stringify(issue))
        await RootStore.userAction.acceptIssue(issue.id)
      } else {
        const issue = await RootStore.userAction.getNewIssueByDevice(device.id)
        // console.log(JSON.stringify(issue))
        const finalIssue = await RootStore.userAction.compliteIssue(issue.id)
        // console.log(JSON.stringify(finalIssue))
        await RootStore.userAction.endIssue(issue.id, {rating: 0})
      }

      const newDevice = await RootStore.userAction.switchDevice(device.id)
      // Жуткий хак для изменения цвета иконки в модале
      // @ts-ignore
      RootStore.modalsUi.device.is_started = newDevice.is_started
      // console.log('New device:', newDevice.is_started)

      toast.update(toastId, {
        render: `${operation} оборудования`,
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })

      setError(null)

      // Задержка перед закрытием модала (для визуала)
      setTimeout(() => {
        hundleClose()
      }, 3000)
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
        setError(data.property)
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <div className="CreateIssue">
        <div className="CreateIssue-content">
          <DialogTitle>Создать заявку</DialogTitle>
          <div className="CreateIssue-inputs"> </div>
          <DialogContent>
            <UserSelect />

            {device.causes ? (
              <Autocomplete
                options = {assigned === 0 
                  ? device.causes 
                  : device.causes.filter((obj: Cause) => obj.role?.id === assigned)
                }
                onChange={(event: any, newValue) => {
                  if (!newValue) return
                  hundleChangeCauses(newValue)
                }}
                getOptionLabel={(option) => option.description}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Возможные причины"
                    placeholder="Другая"
                    variant={variant}
                    margin={margin}
                    error={error?.causes ?? null}
                    helperText={
                      error?.causes ?? 'Если причина другая оставьте пустым'
                    }
                  />
                )}
              />
            ) : null}

            <FormControl style={{ margin: '1em 0' }}>
              <FormLabel>Возможные мастера</FormLabel>
              <RadioGroup defaultValue="Любой">
                {roles.map((role) => {
                  return (
                    <FormControlLabel
                      key={role.id}
                      control={
                        <Radio
                          checked={assigned === role.id}
                          onChange={handleChangeAssigned}
                          name={`${role.id}`}
                        />
                      }
                      label={role.value}
                    />
                  )
                })}
              </RadioGroup>
            </FormControl>

            {/*RootStore.authStore.isAdmin ?(
              <FormControl style={{ paddingLeft: '80px', margin: '1em 0em' }}>
                  <FormLabel>Срочность</FormLabel>
              </FormControl>
            ) : null*/}

          </DialogContent>
        </div>
        <FormControl style={{ margin: '0 0' }}>
          <ProductCard
            className={(device.is_started) ? "CreateIssue-content-item card-item" : "CreateIssue-content-item"}
            title={device.name}
            type="item"
            onClick={hundleSwitchDevice}
          />
          <FormHelperText sx={{ maxWidth: '200px' }}>Запуск/остановка<br /> оборудования</FormHelperText>
        </FormControl>
      </div>

      <DialogActions
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Button color="error" onClick={hundleChangeUrgent}>Срочно!</Button>
        <div>
          <Button onClick={hundleChange}>Создать</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
})

export default CreateIssue